import request from '@/utils/request'

//我的积分
export function MyInit(data) {
  return request({
    url:'User/query_inte',
    method:'post',
    data
  })
}
//积分兑换  分类
export function Myinte(data) {
  return request({
    url:'User/poins_inte',
    method:'post',
    data
  })
}
//省市区
export function getCity(data) {
  return request({
    url:'City/query_city',
    method:'post',
    data
  })
}
//修改个人资料
export function getsave(data) {
  return request({
    url:'User/save_user',
    method:'post',
    data
  })
}
//上传图片
export function getimg(data) {
  return request({
    url:'User/upload',
    method:'post',
    data
  })
}
//个人资料修改密码
export function getsavePass(data) {
  return request({
    url:'User/save_user_pass',
    method:'post',
    data
  })
}
//用户收货地址列表,
export function getsaveress(data) {
  return request({
    url:'User/query_add_ress',
    method:'post',
    data
  })
}
//添加收货地址,
export function getaddress(data) {
  return request({
    url:'User/add_ress',
    method:'post',
    data
  })
}
//修改地址前查询,
export function getfindress(data) {
  return request({
    url:'User/find_add_ress',
    method:'post',
    data
  })
}
//修改地址,
export function getfsaveress(data) {
  return request({
    url:'User/save_add_ress',
    method:'post',
    data
  })
}

//删除地址,
export function getdelete(data) {
  return request({
    url:'User/delete_add_ress',
    method:'post',
    data
  })
}
//订单列表,
export function getOrList(data) {
  return request({
    url:'Order/order_list',
    method:'post',
    data
  })
}
//订单详情列表,
export function getOrFind(data) {
  return request({
    url:'Order/find_order_child',
    method:'post',
    data
  })
}

//订单详情列表,
export function getquerycollection(data) {
  return request({
    url:'User/query_collection',
    method:'post',
    data
  })
}
//订单详情列表,
export function getqueryread(data) {
  return request({
    url:'User/query_read',
    method:'post',
    data
  })
}
//我的留言,
export function getliuyan(data) {
  return request({
    url:'User/query_message',
    method:'post',
    data
  })
}
//申请月结,
export function getmonthly(data) {
  return request({
    url:'User/user_monthly',
    method:'post',
    data
  })
}
//查询申请月结,
export function getstatem(data) {
  return request({
    url:'User/query_user_statem',
    method:'post',
    data
  })
}
//Index/Order/duihuan  积分兑换,  点击兑换直接调这个接口  没有填写信息的,   id  传积分商品id,,
export function getsduihuan(data) {
  return request({
    url:'Order/duihuan',
    method:'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/Mycen.js